import { FileUploader } from 'components/FileUploader/FileUploader';
import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import { FormikToggleField } from 'components/FormikToggleField/FormikToggleField';
import { TextAreaInput } from 'components/TextAreaInput/TextAreaInput';
import { useFormik } from 'formik';
import { type FC, useState } from 'react';

interface Props {
  onChange: (value: File[]) => void;
  hasError: boolean;
  multiple: boolean;
  loading: boolean;
  maxSizeInMB: number;
  confirmRepeatedUploadHeaderMsg: string;
  accept: string;
}

export const FileUploaderGallerySection: FC = () => {
  const [textAreaValue, setTextAreaValue] = useState<string>('');
  const onChange = (files: File[]) => {
    const fileInfos = files.map((file) => ({
      name: file.name,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified,
    }));

    const jsonString = JSON.stringify(fileInfos);
    setTextAreaValue(jsonString);
  };

  const initialValues = {
    onChange,
    hasError: false,
    multiple: false,
    loading: false,
    confirmRepeatedUploadHeaderMsg: '',
    maxSizeInMB: 5,
    accept: '', // accept all file types
  };

  const formik = useFormik<Props>({
    initialValues,
    onSubmit: () => {},
  });

  return (
    <div className='flex flex-col'>
      <div className='flex gap-5'>
        <div className='flex-1'>
          <FileUploader {...formik.values} />
        </div>
        <div className='w-60'>
          <FormikTextField
            formik={formik}
            label='accept'
            name='accept'
            type='text'
          />
          <FormikTextField
            formik={formik}
            label='confirmRepeatedUploadHeaderMsg'
            name='confirmRepeatedUploadHeaderMsg'
            type='text'
          />
          <FormikTextField
            formik={formik}
            label='maxSizeInMB'
            name='maxSizeInMB'
            type='number'
          />
          <FormikToggleField
            className='mb-4'
            formik={formik}
            name='hasError'
            label='hasError'
            labelPosition='right'
            hideStateMessage
          />
          <FormikToggleField
            className='mb-4'
            formik={formik}
            name='loading'
            label='loading'
            labelPosition='right'
            hideStateMessage
          />
          <FormikToggleField
            className='mb-4'
            formik={formik}
            name='multiple'
            label='multiple'
            labelPosition='right'
            hideStateMessage
          />
        </div>
      </div>
      <TextAreaInput value={JSON.stringify(textAreaValue)} disabled />
    </div>
  );
};
